import { useCallback } from 'react';

import { useDataMutation } from '@work4all/data';

import { WebShopDefinition } from '@work4all/models/lib/Classes/WebShopDefinition.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { pickUpdateFields } from '../../../utils/pick-update-fields';
import { WebShopMaskFormValue } from '../types';

type Props = {
  isCreateMode: boolean;
  dirtyFields: unknown;
  onAfterSave: (data: unknown) => void;
};

export const useWebShopSubmitHandler = ({
  isCreateMode,
  dirtyFields,
  onAfterSave,
}: Props) => {
  const [mutate] = useDataMutation<WebShopDefinition, EMode.upsert>({
    entity: Entities.webShopDefinition,
    mutationType: EMode.upsert,
    responseData: { id: null },
    onCompleted: onAfterSave,
  });

  const submitHandler = useCallback(
    async (data) => {
      const mutateData = isCreateMode
        ? data
        : pickUpdateFields<WebShopMaskFormValue>(data, dirtyFields);

      await mutate(mutateData);
    },
    [dirtyFields, isCreateMode, mutate]
  );

  return submitHandler;
};
